import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AddBlock } from '@lyearn/molecules';
import { FilterOption } from '@/components/Filter/types';
import TagsFilter from '@/components/FilterManager/Tags/TagsFilter';
import { TagAvailableOnEnum } from '@/types/schema';

import { TagsMenuItem } from '../../types';

function AddTags({
  tags,
  onChange,
  availableOn,
  EmptyState,
  isSharedItem,
  fetchTagWithProviders,
  subWorkspaceIds,
  disabled,
  className,
}: {
  tags?: TagsMenuItem[];
  onChange: (tags: TagsMenuItem[]) => void;
  availableOn?: TagAvailableOnEnum[];
  EmptyState?: JSX.Element;
  isSharedItem?: boolean;
  fetchTagWithProviders?: boolean;
  subWorkspaceIds?: string[];
  disabled?: boolean;
  className?: string;
}) {
  const { t } = useTranslation('Tags');
  const selectedValues = useMemo(() => tags || [], [tags]);

  const onFilterChange = useCallback(
    (selectedTags: FilterOption[]) => {
      onChange(selectedTags as TagsMenuItem[]);
    },
    [onChange],
  );
  if (disabled) {
    return null;
  }
  return (
    <TagsFilter
      EmptyState={EmptyState}
      availableOn={availableOn}
      fetchTagWithProviders={fetchTagWithProviders}
      isSharedItem={isSharedItem}
      selectedValues={selectedValues}
      showRequiredTags={false}
      subWorkspaceIds={subWorkspaceIds}
      onChange={onFilterChange}>
      <AddBlock className={className} length="short" title={t('Tags:Form.AddTag')} />
    </TagsFilter>
  );
}

export default React.memo(AddTags);
